export default {
  SHOW_DIALOG: '@YOLA_TEMPLATE_GALLERY/DIALOG/SHOW_DIALOG',
  HIDE_DIALOG: '@YOLA_TEMPLATE_GALLERY/DIALOG/HIDE_DIALOG',
};
